<template>

  <div class="main-body">

    <div style="background-color: #2a2f32;">
      <el-row style="color: rgb(255, 255, 255);padding-bottom: 60px;">
        <el-col :span="18">
          <div style="padding-left: 15px; padding-top: 8px; padding-bottom: 6px;">
            <div style="padding: 20px; font-size: 16px; color: #dddddd;">
              <a style="font-weight: 700; color: #ffffff;" href="javascript:void(0);" @click="toCurrentClass">
                学习中的课程</a>
              &nbsp;/&nbsp;<span>{{singleUserLearnTaskView.themeName}}</span>
              &nbsp;/&nbsp;<span>{{singleUserLearnTaskView.currentLearnTaskItem.taskName}}</span>
            </div>
            <div v-if="singleUserLearnTaskView.currentLearnTaskItem.taskType==='video'">
              <d-player id="player" ref="player" :options="options" style="height: 750px;border-radius: 8px;"/>
            </div>
            <div v-else-if="singleUserLearnTaskView.currentLearnTaskItem.taskType==='pdf'">
              <iframe style="width:100%;height: 750px;border-radius: 8px;border: 1px solid #000000;"
                      :src="'/static/pdfjs-2.7.570/web/viewer.html?file=' + singleUserLearnTaskView.currentLearnTaskItem.taskUrl"></iframe>
            </div>
            <div v-else-if="singleUserLearnTaskView.currentLearnTaskItem.taskType==='img'">
              <iframe style="width:100%;height: 750px;border-radius: 8px;border: 1px solid #000000;"
                      :src="singleUserLearnTaskView.currentLearnTaskItem.taskUrl"></iframe>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div style="padding-left: 20px;padding-right: 20px; height: 780px;">
            <div style="padding-top: 70px;padding-bottom: 20px; padding-left: 0; font-size: 18px;">
              课程目录:
            </div>
            <div>
              <div class="media-item" style="height: 630px;overflow: auto;">
                <h4 class="media-item-title">{{singleUserLearnTaskView.themeName}}</h4>

                <div class="media" v-for="learnTaskItem in singleUserLearnTaskView.learnTaskItemList">
                  <h4 class="media-heading">
                    <a href="javascript:void(0);"
                       @click="toLearn(learnTaskItem.taskId)"
                       v-bind:class="[(learnTaskItem.taskId === singleUserLearnTaskView.currentLearnTaskItem.taskId) ? 'active' : 'default']">
                      <i class="el-icon-video-play"/>
                      {{learnTaskItem.taskName}}
                      <i class="el-icon-success" v-show="learnTaskItem.learnStatus==='FINISH'" style="color: #00b43c;"/>
                    </a>
                  </h4>
                </div>

              </div>
            </div>
          </div>

          <div style="padding-left: 20px;padding-right: 20px;">
            <el-button type="danger" style="width: 100%;" @click="finishLearn">完成本课时学习</el-button>

            <el-dialog
              top="30vh"
              :center="true"
              :visible.sync="dialogVisible"
              width="30%">
              <div style="text-align: center;font-weight: 700;font-size: 18px;">
                即将完成当前课时的学习...

                <div v-show="singleUserLearnTaskView.nextLearnTaskItem == null" style="margin-top: 15px;">
                  <el-row>
                    <el-col :span="7" :offset="3" style="font-weight: normal; font-size: 14px;">内容质量评分:</el-col>
                    <el-col :span="9">
                      <el-rate
                        v-model="courseStart"
                        show-score
                        text-color="#ff9900">
                      </el-rate>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top: 10px; margin-bottom: 10px;">
                    <el-col :span="7" :offset="3" style="font-weight: normal; font-size: 14px;">老师指导评分:</el-col>
                    <el-col :span="9">
                      <el-rate
                        v-model="serverStart"
                        show-score
                        text-color="#ff9900">
                      </el-rate>
                    </el-col>
                  </el-row>

                  <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入您的建议或反馈"
                    style="width: 300px;"
                    v-model="courseEvaluate">
                  </el-input>

                </div>
              </div>
              <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="reload" size="medium">重新学习</el-button>
              <el-button type="success" v-if="singleUserLearnTaskView.nextLearnTaskItem" @click="toNextLearn"
                         size="medium">学习下一节</el-button>
              <el-button type="success" v-else @click="toNextLearn" size="medium">完成课程</el-button>
              </span>
            </el-dialog>

            <el-dialog
              top="30vh"
              :center="true"
              :visible.sync="finishDialogVisible"
              width="30%">
              <div style="text-align: center;font-weight: 700;color: #00b43c;font-size: 18px;">
                已完成本课程全部课时的学习!
              </div>
            </el-dialog>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="comments-body">
      <div>
        <el-input type="textarea" :rows="3" placeholder="请输入评论" v-model="comment"/>
        <div style="width: 100%;clear: both;height: 35px;line-height:35px;padding-top: 5px;padding-bottom: 5px;">
          <el-button style="float:right;" @click="addComment">发布评论</el-button>
        </div>
      </div>
      <hr style="margin-bottom: 10px;border:0;border-top: 1px solid #eee;">
      <div class="comments-list">
        <div class="media" v-for="comment in comments">
          <div class="media-left">
            <a>
              <img class="media-object" :src="photo"
                   alt="..." style="width:48px;height:48px;border-radius: 24px">
            </a>
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{comment.username}}</h4>
            <div class="comments-text">{{comment.comment}}</div>
            <div style="text-align: right; padding-top: 10px;">
              <span class="comment-time">{{comment.commentDate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import photo from "@/assets/photo.png";
  import { doGetSingleUserLearnTaskView, doFinishLearnTask, doGetCommits, doAddComment } from '@/utils/server';

  export default {
    name: "index",
    data() {
      return {
        photo: photo,
        dialogVisible: false,
        finishDialogVisible: false,
        themeCode: '',
        currentTaskId: '',
        options: {
          container: document.getElementById("dplayer"), //播放器容器
          mutex: false, //  防止同时播放多个用户，在该用户开始播放时暂停其他用户
          theme: "#b7daff", // 风格颜色，例如播放条，音量条的颜色
          loop: false, // 是否自动循环
          lang: "zh-cn", // 语言，'en', 'zh-cn', 'zh-tw'
          screenshot: false, // 是否允许截图（按钮），点击可以自动将截图下载到本地
          hotkey: true, // 是否支持热键，调节音量，播放，暂停等
          preload: "auto", // 自动预加载
          volume: 0.7, // 初始化音量
          playbackSpeed: [ 0.5, 0.75, 1, 1.25, 1.5, 2, 3 ], //可选的播放速度，可自定义
        },
        singleUserLearnTaskView: { currentLearnTaskItem: {}, nextLearnTaskItem: {}, learnTaskItemList: [] },
        comment: '',
        comments: [],
        courseStart: 0,
        serverStart: 0,
        courseEvaluate: ''
      }
    },
    methods: {
      getSingleUserLearnTaskView() {
        let request = { themeCode: this.themeCode, currentTaskId: this.currentTaskId };
        doGetSingleUserLearnTaskView(request)
          .then(response => {
            this.singleUserLearnTaskView = response.data;
            this.options = {
              ...this.options,
              video: {
                url: this.singleUserLearnTaskView.currentLearnTaskItem.taskUrl,
                pic: this.singleUserLearnTaskView.currentLearnTaskItem.taskImg
              }
            };
            // 获取评论
            this.getCommits(this.singleUserLearnTaskView.currentLearnTaskItem.taskId);
          });
      },
      getCommits(taskId) {
        doGetCommits({ taskId: taskId })
          .then(res => {
            this.comments = res.data;
          })
      },
      addComment() {
        if (this.comment === '') {
          this.$message({
            showClose: true,
            message: '请填写内容',
            type: 'error'
          });
          return;
        }
        let request = { taskId: this.singleUserLearnTaskView.currentLearnTaskItem.taskId, comment: this.comment };
        doAddComment(request)
          .then(response => {
            this.$message({
              showClose: true,
              message: '发布成功',
              type: 'success'
            });
            this.getCommits(this.singleUserLearnTaskView.currentLearnTaskItem.taskId);
          })
      },
      toCurrentClass() {
        this.$router.push({ path: '/CurrentClass' });
      },
      toLearn(taskId) {
        this.$router.push({
          path: '/PubContinue',
          query: { themeCode: this.themeCode, currentTaskId: taskId }
        });

        location.reload();
      },
      finishLearn() {
        if (this.singleUserLearnTaskView.learnStatus === 'FINISH') {
          this.finishDialogVisible = true;
        } else {
          this.dialogVisible = true
        }
      },
      toNextLearn() {
        let request = {
          themeCode: this.singleUserLearnTaskView.themeCode,
          taskId: this.singleUserLearnTaskView.currentLearnTaskItem.taskId,
          courseStart: this.courseStart,
          serverStart: this.courseStart,
          courseEvaluate: this.courseEvaluate
        };

        if (this.singleUserLearnTaskView.nextLearnTaskItem == null) {
          if (this.courseStart === 0 || this.courseStart === 0) {
            this.$message({
              message: '请选择您的评分',
              type: 'warning'
            });
            return;
          }
        }

        doFinishLearnTask(request)
          .then(response => {
            this.dialogVisible = false;
            if (response['data'] === 'INIT') {
              this.toLearn(this.singleUserLearnTaskView.nextLearnTaskItem.taskId);
            } else {
              this.finishDialogVisible = true;
              this.getSingleUserLearnTaskView();
            }
          })
      },
      reload() {
        location.reload();
      },
    },
    mounted() {
      this.themeCode = this.$route.query.themeCode;
      this.currentTaskId = this.$route.query.currentTaskId;
      this.getSingleUserLearnTaskView();
    },
    created() {
      // 禁止右键菜单
      document.oncontextmenu = function(){ return false; };
      // 禁止文字选择
      document.onselectstart = function(){ return false; };
      // 禁止复制
      document.oncopy = function(){ return false; };
      // 禁止剪切
      document.oncut = function(){ return false; };
      // 禁止粘贴
      document.onpaste = function(){ return false; };
    }
  }
</script>

<style scoped>

  .media-item {
    margin-bottom: 12px;
  }

  .media-item-title {
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 5px;
  }

  .media {
    margin-top: 0;
    color: #333;
  }

  .media-heading {
    font-weight: 200;
    margin-top: 3px;
    margin-bottom: 3px;
    font-size: 14px;
    margin-left: 1em;
  }

  .media-body {
    width: 10000px;
  }

  .media, .media-body {
    overflow: hidden;
    zoom: 1;
  }

  .media a {
    text-decoration: none;
  }

  .media a.active {
    color: #f75d5f;
  }

  .media a.default {
    color: #fff;
  }

  .media a:hover {
    color: #f75d5f;
  }

  .media-body, .media-left, .media-right {
    display: table-cell;
    vertical-align: top;
  }

  .media-left, .media > .pull-left {
    padding-right: 10px;
  }

  .comments-body {
    width: 1000px;
    margin: 20px auto;
  }

  .comments-list h4 {
    font-size: 16px;
    color: #333;
  }

  .comments-list .media-heading {
    font-weight: 700;
    margin-left: 0;
    color: #333;
  }

  .comments-list .comments-text {
    font-size: 14px;
    color: #666666;
    background-color: #ffffff;
    padding: 10px;
    border-radius: 2px;
    border: 1px solid #eeeeee;
  }

  .comments-list .media {
    min-height: 50px;
    border: 1px dashed #999999;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;
    background-color: #f8fafc
  }

</style>



// WEBPACK FOOTER //
// src/pages/hourweb/pubcontinue/index.vue